// Env-driven runtime configuration (the one allowed frontend change for the
// monorepo port). API bases fall back to the current prod value so an unset
// environment reproduces prod behavior exactly (faithful port). Cognito identity
// is account-scoped and has no safe default, so it is required. CRA inlines
// process.env.REACT_APP_* at build time.
//
// Staging note: REACT_APP_MIND_API_BASE for staging is the factor-mind staging
// HTTP API with NO `/prod` prefix (e.g. https://j0orkmidvf.execute-api.us-east-1.amazonaws.com).

const stripTrailingSlash = (value) => value.replace(/\/+$/, '');

function required(name, value) {
  if (!value?.trim())
    throw new Error(
      `${name} is not set. The factor-comps-app unit declares it in outputEnv; the deploy hydrates it from the identity stack.`,
    );
  return value.trim();
}

export const COMPS_API_BASE = stripTrailingSlash(
  process.env.REACT_APP_COMPS_API_BASE ||
    'https://3h3er97cni.execute-api.us-east-1.amazonaws.com/prod',
);

export const MIND_API_BASE = stripTrailingSlash(
  process.env.REACT_APP_MIND_API_BASE ||
    'https://k3bgnw08u6.execute-api.us-east-1.amazonaws.com/prod',
);

export const MIND_ASSETS_BASE = stripTrailingSlash(
  process.env.REACT_APP_MIND_ASSETS_BASE ||
    'https://factor-mind-assets.s3.us-east-1.amazonaws.com',
);

const origin =
  typeof window !== 'undefined'
    ? window.location.origin
    : 'http://localhost:3000';

// Managed login config (Cognito hosted OAuth code flow). No identity pool: no
// code in this app uses AWS credentials, only the bearer token.
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: required(
        'REACT_APP_COGNITO_USER_POOL_ID',
        process.env.REACT_APP_COGNITO_USER_POOL_ID,
      ),
      userPoolClientId: required(
        'REACT_APP_COGNITO_CLIENT_ID',
        process.env.REACT_APP_COGNITO_CLIENT_ID,
      ),
      loginWith: {
        oauth: {
          domain: required(
            'REACT_APP_COGNITO_SIGN_IN_DOMAIN',
            process.env.REACT_APP_COGNITO_SIGN_IN_DOMAIN,
          ),
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [`${origin}/auth/callback`],
          redirectSignOut: [`${origin}/`],
          responseType: 'code',
        },
      },
    },
  },
};

if (!process.env.REACT_APP_ADMIN_BASE_URL?.trim())
  throw new Error('REACT_APP_ADMIN_BASE_URL is required');
export const ADMIN_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_ADMIN_BASE_URL,
);
